// ProductView.tsx
import { Helmet } from "react-helmet-async";
import Home from "./Home";
import { useAddProductContext } from "../Contexts/AddProductContext";
import { useStoreContext } from "../Contexts/StoreContext";
import { useLayoutContext } from "../Contexts/LayoutContext";

const ProductView = () => {

    const { product } = useAddProductContext();
    const { currentStore } = useStoreContext();
    const { company } = useLayoutContext();

    return (
        <>
            {product &&
                <Helmet>
                    <title>{product.name}</title>
                    <meta name="description" content={product.description ?? ""} />
                    {/* <meta name="keywords" content={} /> Backend */}
                    <meta name="robots" content="index, follow" />
                    <meta name="author" content={currentStore.name} />
                    <link rel="canonical" href={window.location.href} />

                    {/* Open Graph */}
                    <meta property="og:title" content={product.name} />
                    <meta property="og:description" content={product.description ?? ""} />
                    <meta property="og:image" content={product?.photos?.medium ?? ""} />

                    {company.social_links.twitter &&
                        <>
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:title" content={product.name} />
                            <meta name="twitter:description" content={product.description ?? ""} />
                            <meta name="twitter:image" content={product?.photos?.medium ?? ""} />
                            <meta name="twitter:site" content={company.social_links.twitter} />
                        </>
                    }
                </Helmet>
            }

            <Home />
        </>
    );
}
export default ProductView;